// extracted by mini-css-extract-plugin
export default {"root":"styles_root__TIkeR","formContent":"styles_formContent__sWTTy","header":"styles_header__PjOYy","saveWrap":"styles_saveWrap__+NJJm"};